"use strict";
exports.__esModule = true;
exports.KEYSET_PAGINATION_VER = exports.KeysetPaginationPageAction = void 0;
var KeysetPaginationPageAction;
(function (KeysetPaginationPageAction) {
    KeysetPaginationPageAction["NEXT"] = "next";
    KeysetPaginationPageAction["PREVIOUS"] = "previous";
})(KeysetPaginationPageAction = exports.KeysetPaginationPageAction || (exports.KeysetPaginationPageAction = {}));
exports.KEYSET_PAGINATION_VER = 2;
//# sourceMappingURL=keyset_pagination.js.map